// extracted by mini-css-extract-plugin
export var root = "J_wQ";
export var wrapper = "J_wR";
export var image = "J_wS d_v d_x d_V";
export var crop = "J_wT";
export var round = "J_wV";
export var fixedHeight = "J_wW";